import { config } from '@uhg-abyss/web/tools/config';
import { data as breadcrumbNameMap } from '@src/content_data/BreadcrumbsUtils';

export const checkInternalRole = (dsUserData) => {
  const { isInternalUser, jobFunctionCodes } = dsUserData || {};
  if (isInternalUser) {
    const hasRoleAccess = jobFunctionCodes?.filter((element) => {
      return element === config('CC_INTERNAL_ROLE_IDS');
    });
    if (hasRoleAccess && hasRoleAccess.length > 0) {
      return true;
    }
  }

  return false;
};

export const leftNavMap = (
  leftNavContent,
  leftHeaderItems,
  leftNavContentSub = []
) => {
  const content = leftNavContent?.map((el) => {
    const leftItems = leftHeaderItems?.filter((item) => {
      return item.active && item.tagId === el.tagId;
    });

    // Check if the element has a submenu
    let submenu = [];
    if (el.hasSubmenu) {
      const submenuItems = leftNavContentSub?.filter((subItem) => {
        return subItem.tagId === el.tagId;
      });

      submenu = submenuItems
        ?.map((subItem) => {
          const submenuPaths = leftHeaderItems?.filter((headerItem) => {
            return headerItem.active && headerItem.tagId === subItem.tag;
          });

          return {
            menuTitle: subItem.tag, // Add menu title
            paths: submenuPaths || [], // Add paths
          };
        })
        .filter((submenuItem) => {
          return submenuItem.paths.length > 0;
        }); // Filter out ite
    }

    if (!leftItems || leftItems.length === 0) {
      return null; // Return nothing if the condition fails
    }

    return {
      ...el,
      paths: leftItems,
      submenu, // Add submenu property as array of objects
    };
  });

  // Filter out null values to ensure only valid items are returned
  return content?.filter((item) => {
    return item != null;
  });
};

export const getLeftNavData = (dsUserInfo, leftNavContent, leftHeaderItems) => {
  const isUserSignedIn =
    dsUserInfo && dsUserInfo.uuid && dsUserInfo.uuid !== 'null';
  const ignoreTags = ['intro', 'getting-started'];
  const pathsData = leftNavMap(leftNavContent, leftHeaderItems);
  const dataList = pathsData?.map((element) => {
    if (element.active && !ignoreTags.includes(element.tagId)) {
      let dataElement = {
        ...element,
        accessible: true,
        accessibleToAll: true,
      };

      let { paths } = element;
      if (!isUserSignedIn) {
        paths = element?.paths?.filter((path) => {
          return !path.name
            ?.toLowerCase()
            .includes('technical demo videos'.toLowerCase());
        });
      }

      if (paths && paths.length > 0) {
        dataElement = {
          ...element,
          paths,
          accessible: true,
          accessibleToAll: true,
        };
        return dataElement;
      }
    }
    if (element?.tagId === 'getting-started') {
      const sortedElement = { ...element };
      const videoMediaPathsList = sortedElement?.paths;
      const gettingStartedPath = videoMediaPathsList?.shift();
      videoMediaPathsList.sort((a, b) => {
        return a.id.localeCompare(b.id);
      });
      const sortedVideoPathList = [gettingStartedPath, ...videoMediaPathsList];
      sortedElement.paths = sortedVideoPathList;
      return sortedElement;
    }
    return element;
  });
  return dataList;
};

export const leftNavData = (
  userInfo,
  leftNavContent,
  leftHeaderItems,
  leftNavContentSub
) => {
  const pathsData = leftNavMap(
    leftNavContent,
    leftHeaderItems,
    leftNavContentSub
  );
  const isUserSignedIn = userInfo && userInfo.uuid;

  const dataList = pathsData?.map((element) => {
    if (element.active) {
      let paths = element?.paths;
      if (!isUserSignedIn) {
        paths = element?.paths?.filter((path) => {
          return !path.path?.includes('video-demos'.toLowerCase());
        });
      }
      if (paths && paths.length > 0) {
        const dataElement = {
          ...element,
          paths,
        };
        return dataElement;
      }
    }

    if (element?.tagId === 'getting-started') {
      const sortedElement = { ...element };
      const videoMediaPathsList = sortedElement?.paths;
      const gettingStartedPath = videoMediaPathsList?.shift();
      videoMediaPathsList.sort((a, b) => {
        return a.id.localeCompare(b.id);
      });
      const sortedVideoPathList = [gettingStartedPath, ...videoMediaPathsList];
      sortedElement.paths = sortedVideoPathList;
      return sortedElement;
    }

    return element;
  });

  return dataList;
};

export const mapBreadcrumbsData = (breadcrumbsData) => {
  if (!breadcrumbsData || !Array.isArray(breadcrumbsData)) {
    return [];
  }

  return breadcrumbsData
    .filter((crumb) => {
      // Only include entries that have a valid title mapping
      return (
        breadcrumbNameMap[crumb.label] !== undefined &&
        breadcrumbNameMap[crumb.label] !== null
      );
    })
    .map((crumb) => {
      return {
        title: breadcrumbNameMap[crumb.label],
        href: `/${crumb.url}`,
      };
    });
};
